import React from 'react';

export const VisualizationControlContext = React.createContext({

})

export const LanguageContext = React.createContext({

})

export const PresentationContext = React.createContext({

})
